var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"h-full d-flex align-center justify-center"},[_c('div',{staticClass:"w-full h-full"},[_c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":_setup.ID_DOM}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }